import { useState } from 'react';

import type {
  ITurnOffItemTime,
  ShutdownTimeOption,
} from 'features/menu-page/domain';

const INITIAL_STATE = {
  disabled: true,
  opt: '' as ShutdownTimeOption,
  customDate: new Date(0),
} as const;

export function useTurnOffItemTime(props: Props) {
  const { turnOffCTA } = props;

  const [status, setStatus] = useState<{
    disabled: boolean;
    opt: ShutdownTimeOption;
    customDate: Date;
  }>(INITIAL_STATE);

  const handleShutdownTimeOpt = (opt: ShutdownTimeOption) => {
    const isCustom = opt === 'CUSTOM';
    setStatus(_ps => ({
      opt,
      disabled: isCustom,
      customDate: isCustom ? _ps.customDate : new Date(0),
    }));
  };

  const handleShutdownCustomDate = (date: Date) => {
    setStatus(_ps => ({ ..._ps, disabled: false, customDate: date }));
  };

  const handleCallToAction = () => {
    if (status.disabled) return;
    turnOffCTA({
      shutdownTimeOption: status.opt,
      customDate: status.customDate,
    });
  };

  return {
    status,
    handleShutdownTimeOpt,
    handleShutdownCustomDate,
    handleCallToAction,
  };
}

interface Props {
  turnOffCTA: (p: ITurnOffItemTime) => void;
}
